import { useEffect, useState } from "react"
import FloatTitleCard from "../../components/cards/floatTitleCard"
import EditUserModal from "../../components/modals/EditUser/EditUserModal"
import TurnsCounts from "../../components/TurnsCount/TurnsCount"
import { useNavigate } from "react-router-dom"
import apiConfig from '../../utilities/apiConfig.json'
import serverConfig from '../../utilities/serverConfig.json'
import axios from "axios"
import { toast } from "react-toastify"
import { useSelector } from "react-redux"
import PersonIcon from '@mui/icons-material/Person';
import MyProfileSkt from "../../components/Skeletons/MyProfileSkt"

const user_token = localStorage.getItem('token')
const getMeRoute = serverConfig.server.url + apiConfig.api.getAPIs.getProfile

const MyProfile = () => {

    const [data, setData] = useState(null)
    const [loading, setLoading] = useState(true)

    const {
        user_id,
        first_name,
        last_name,
        biography,
        awaithing_confirmation_events_count,
        awaithing_reference_events_count,
        done_events_count,
        city_id,
        city_name,
        file,
        mobile,
        national_id,
        province_id,
        province_name
    } = data || {}

    const { token: localToken } = useSelector((state) => state.user);

    const navigate = useNavigate()
    const headers = { Authorization: "Bearer " + (user_token ?? localToken) };

    useEffect(() => {

        if (!Boolean(!!user_token)) {
            localStorage.clear()
            setLoading(false)
            navigate('/')
        }

        const getUserData = async () => {

            try {

                setLoading(true)
                const { data } = await axios.get(getMeRoute, { headers })

                if (data?.status === 'success') return setData(data?.data)

                toast.error(data?.errors)
                navigate('/login')

            } catch (error) { toast.error('خطا در دریافت اطلاعات') }
            finally { setLoading(false) }

        }

        getUserData()

    }, [user_token])

    return (
        <>
            {/* breadcrumb */}
            <section className="w-100 d-flex align-items-center gap-1 px-3 py-1 iran-sans bread_crumb">

                <p className="color-iso-gray-300 m-0 fs-14 fw-regularer z-1 cursor-pointer">پذیرکس</p>

                <div className="d-flex align-items-center justify-content-center z-1 tw-size-6">
                    <img src="./chevron_left.png" alt="right arrow" />
                </div>

                <p className="fs-14 fw-regularer m-0 color-bootstrap-gray-700 z-1">پروفایل من</p>

                {/* better to be removed */}
                <span
                    className="position-absolute w-100 tw-left-0 tw-right-0 tw-bg-[#E9ECEF] tw-fixed tw-h-8">
                </span>

            </section>
            {/* breadcrumb */}

            {
                loading
                    ?
                    <MyProfileSkt />
                    :
                    <>
                        <section className="py-3 w-100 d-flex flex-column gap-4">

                            <FloatTitleCard title="مشخصات کاربر">

                                <div className="d-flex align-items-center justify-content-between iran-sans">

                                    <div className="d-flex align-items-center justify-content-between gap-3">

                                        {
                                            file
                                                ?
                                                <img className="rounded-100" src={file} alt="ashraphy" />
                                                :
                                                <div className="background-bootstrap-gray-500 tw-rounded-full tw-overflow-hidden tw-size-12 tw-flex tw-items-center tw-justify-center">
                                                    <PersonIcon />
                                                </div>
                                        }

                                        <div className="d-flex flex-column">
                                            <p className="fs-16 fw-medium m-0 color-bootstrap-gray-900">{first_name + ' ' + last_name}</p>
                                            <p className="fs-16 fw-regularer m-0 color-bootstrap-gray-700">{mobile}</p>
                                        </div>

                                    </div>

                                    <button
                                        data-bs-toggle="modal"
                                        data-bs-target="#editUserData"
                                        className="d-flex m-0 p-0 align-items-center justify-cotent-center tw-size-6 tw-border-none tw-bg-inherit"
                                    >
                                        <img src={file || './person_edit.png'} alt="person edit" />
                                    </button>

                                </div>

                            </FloatTitleCard>

                            <FloatTitleCard title="نوبت های من ">

                                <div className="d-flex flex-column align-items-center justify-content-center iran-sans gap-4">

                                    <div className="d-flex flex-column gap-4 gap-sm-0 flex-sm-row align-items-center w-100 justify-content-evenly">

                                        <TurnsCounts color={'#E29908'} count={awaithing_confirmation_events_count} title={'در انتظار تایید'} />
                                        <TurnsCounts color={'#6C757D'} count={done_events_count} title={'اتمام رسیده'} />
                                        <TurnsCounts color={'#52C41A'} count={awaithing_reference_events_count} title={'درانتظار مراجعه'} />

                                    </div>

                                    <div className="d-flex m-0 p-0 align-items-center gap-2 justify-cotent-center tw-cursor-pointer">
                                        <img src="./calendar_month (1).png" alt="calendar_month (1).png" />
                                        <p className="m-0 color-iso-blue-300">همه نوبت ها</p>
                                    </div>

                                </div>

                            </FloatTitleCard>

                            {/* notifications if available */}
                            <FloatTitleCard title="اعلانات">

                                <div className="tw-grid md:tw-grid-cols-2 tw-gap-3">

                                    <UserNotification />
                                    <UserNotification />
                                    <UserNotification />
                                    <UserNotification />

                                </div>

                            </FloatTitleCard>

                        </section>

                        <EditUserModal {...data} />
                    </>
            }
        </>
    )
}

const UserNotification = () => {
    return (
        <div className="d-flex flex-column gap-2 w-100 border flex-shrink-0 flex-grow-1 w-25 border-bootstrap-gray-300 rounded p-2 background-bootstrap-gray-100">

            <div className="d-flex align-content-center gap-2">
                <div
                    className="bg-primary d-flex align-items-center justify-content-center tw-w-6 tw-cursor-pointer tw-rounded-lg"
                >
                    <img src="./notifications.png" alt="notification" />
                </div>
                <p className="m-0 fs-16 fw-regularer iran-sans">این یک متن برای تیتر است</p>
            </div>

            <p className="m-0 fs-14 fw-regular color-bootstrap-gray-600">برای ویرایش هر قسمت روی بخش موردنظر کلیک کنید .</p>

            <div className="d-flex align-items-center justify-content-between">

                <p className="m-0">1402/10/20</p>

                <div className="d-flex align-self-center gap-1 tw-cursor-pointer">

                    <p className="m-0 color-iso-blue-300">جزئیات بیشتر</p>

                    <div className="d-flex align-self-center justify-content-center tw-size-6 tw-p-[6px]">
                        <img src="./chevron_left (2).png" alt="left arrow" />
                    </div>

                </div>

            </div>

        </div>
    )
}

export default MyProfile